{
  "modelPortfolioTable": {
    "name": "Nombre del modelo",
    "newModelName": "Nombre nuevo del modelo",
    "newModelNameBottomLabel": "Puede cambiar esto después en Detalles del modelo.",
    "theme": "Grupo",
    "description": "Descripción del modelo",
    "tag": "Etiqueta",
    "type": "Tipo",
    "#OfAccounts": "# de cuentas",
    "#OfPortfolios": "# Carteras",
    "assetClass": "Clase de activo",
    "status": "Estado",
    "valueAssigned": "Valor asignado",
    "filterModal": {
      "none": "Ninguno",
      "modalTitle": "Filtrar carteras modelo",
      "groupTitle": "Grupo"
    },
    "createModel": "Crear modelo nuevo",
    "createTheme": "Crear grupo nuevo",
    "modelFamily": "Familia modelo",
    "totalCount": "Contar",
    "actions": {
      "clone": "Clonar modelo",
      "edit": "Editar modelo",
      "activate": "Activar modelo",
      "draft": "Mover a Borradores",
      "archive": "Mover a archivado"
    },
    "error": {
      "transitionModelPortfolio": "No se puede realizar la transición de la cartera modelo"
    },
    "archive": {
      "disabledTooltip": "No se puede archivar: actualmente asignado(s) a {{count}} subcuenta(s) o meta(s).",
      "disabledTooltipUnknown": "No se puede archivar: no se pudo cargar el uso. Intente actualizar."
    }
  },
  "createModelPortfolio": {
    "name": "Nombre del modelo",
    "description": "Descripción del modelo",
    "type": "Tipo de modelo",
    "FROM_SCRATCH": "Desde cero",
    "FROM_TEMPLATE": "Desde una plantilla",
    "label": "Crear cartera modelo",
    "driftCalculationMethodLabel": "Método de Cálculo de Desviación",
    "driftTolerancePercentLabel": "Tolerancia de Desviación",
    "driftInherited": "Heredado (actualmente {{method}})",
    "driftToleranceRangeError": "Ingrese un número entero entre 5 y 20, o déjelo en blanco para heredar.",
    "driftSettingsTooltip": "Cuánto puede desviarse una cartera de su objetivo antes de que se marque la necesidad de rebalanceo. Déjelo en blanco para heredar la configuración predeterminada de la organización. Las bandas absolutas tienen un límite de 0% y 100%. Por lo tanto, un objetivo del 5% con una banda del 10% se activa entre el 0% y el 15%.",
    "driftToleranceHint": "Ingrese un número entero entre 5-20%, o déjelo en blanco para heredar",
    "driftInheritedUnknown": "Heredado"
  },
  "strategy": {
    "label": "Estrategia del modelo",
    "STANDARD": "Estándar",
    "ASSET_CLASS": "Agrupado por clase de activo"
  },
  "assetClassIPSDisclaimer": "Estos valores son solo para fines informativos",
  "assetClassLevel": "Nivel de clase de activo",
  "assetClassLevelPlaceholder": "Seleccionar nivel de clase de activo",
  "PRIMARY": "Clase de activos primaria",
  "SECONDARY": "Clase de activos secundaria",
  "TERTIARY": "Clase de activos terciaria",
  "autoTarget": "Objetivo automático",
  "unassigned": "Sin asignar",
  "withinGroupPercent": "% del grupo",
  "riskProfile": {
    "CONSERVATIVE": "Tradicional",
    "MODERATELY_CONSERVATIVE": "Tradicional moderado",
    "MODERATE": "Moderado",
    "GROWTH": "Crecimiento",
    "AGGRESSIVE": "Agresivo",
    "VERY_AGGRESSIVE": "Muy agresivo"
  },
  "addSecurity": "Añadir más seguridad",
  "addCash": "+ Agregar efectivo",
  "cashEquivalentSecurity": "Valores equivalentes al efectivo",
  "createNewTemplate": "Crear plantilla nueva",
  "selectTemplate": "Seleccione plantilla",
  "templateName": "Nombre de la plantilla",
  "templateDescription": "Descripción de la plantilla",
  "createAndUseTemplate": "Crear y usar plantilla",
  "addAssetClassBranch": "Añadir más",
  "min": "Mín",
  "max": "Máx",
  "actualPercentage": "% real",
  "assetClasses": "Clases de activos",
  "assetClass": "Clase de activo",
  "assetAllocation": "Asignación de activos",
  "portfolioDetails": {
    "details": {
      "fundamentalDetailsLink": "Enlace a detalles fundamentales",
      "zeroPercentCash": "0% efectivo",
      "riskProfile": "Perfil de riesgo"
    }
  },
  "remove": "Eliminar",
  "cashEquivalent": "Equivalente en efectivo",
  "portfolio": {
    "tabs": {
      "assetAllocation": "Asignación de activos",
      "details": "Detalles",
      "invPolicyStatement": "Declaración de política de inversión",
      "auditLog": "Registro de auditoría"
    },
    "edit": {
      "save": "Guardar",
      "cancel": "Cancelar"
    },
    "details": {
      "genDetails": "Detalles generales",
      "name": "Nombre",
      "suggestable": "Sugestionable",
      "modelFamily": "Familia modelo",
      "url": "URL",
      "riskReturn": "Riesgo y rendimiento",
      "lowThresholdScore": "Puntuación mínima requerida",
      "minScore": "Puntuación mínima",
      "maxScore": "Puntuación máxima",
      "riskReturnLevel": "Nivel de riesgo/rendimiento",
      "forecastRateReturn": "Tasa de rendimiento prevista",
      "forecastStandardDeviation": "Desviación estándar prevista",
      "riskProfileName": "Nombre del perfil de riesgo",
      "riskProfileDescription": "Descripción del perfil de riesgo",
      "suggest": {
        "yes": "Sí",
        "no": "No"
      }
    },
    "policyAndAssets": {
      "description": "Descripción",
      "investmentObjective": "Objetivo de la inversión",
      "liquidity": "Liquidez",
      "disclaimer": "Descargo de responsabilidad",
      "assetAllocation": "Asignación de activos"
    },
    "noAccess": "No tiene acceso de lectura. Comuníquese con su administrador.",
    "success": "Cartera modelo actualizada correctamente",
    "createActiveSuccess": "Cartera modelo activa creada correctamente.",
    "draftSaveSuccess": "Borrador de cartera modelo guardado correctamente.",
    "saveError": "Error al guardar la cartera modelo",
    "missingAssetClassLevel": "Seleccione un nivel de clase de activo antes de guardar una cartera agrupada por clase de activo.",
    "error": "No se pudo actualizar la cartera modelo",
    "exceedsTotalAllocation": "Excede la asignación total",
    "totalAllocationError": "El porcentaje actual de {{totalPercentage}} excede la asignación máxima permitida. Ajuste la asignación objetivo a máximo {{maxPercentage}}",
    "ok": "Aceptar",
    "noSecuritiesUrl": "No se encontraron valores",
    "securitiesOrderedByTaxRank": "Los valores se ordenan por rango fiscal. Para cambiarlos, puede arrastrarlos y soltarlos o actualizarlos manualmente.",
    "zeroPercentError": "No se permiten valores con una asignación del 0%.",
    "noFinancialProductError": "No se permiten valores sin producto financiero.",
    "noPercentageError": "No se permiten valores sin porcentaje.",
    "invalidPrimaryAssetClass": "No se permiten valores sin clase de activo principal.",
    "noSecurityError": "No se encontraron valores",
    "incompleteAllocationError": "Las asignaciones de clases de activos deben totalizar exactamente el 100% antes de poder continuar.",
    "unassignedSecuritiesError": "Todos los valores deben pertenecer a un grupo de clase de activo.",
    "groupAllocationError": "Cada grupo de clase de activo debe tener al menos un valor y sus asignaciones deben totalizar exactamente el 100%.",
    "duplicateTaxRankError": "No se permiten rangos fiscales duplicados. Asegúrese de que cada valor tenga un rango fiscal único.",
    "taxRankGapsError": "Los rangos fiscales deben comenzar en 1 y no tener brechas. Asegúrese de que los rangos formen una secuencia consecutiva a partir de 1.",
    "strategyChangedSecuritiesCleared": "El cambio de estrategia ha borrado la lista de valores.",
    "updateError": "Error al actualizar la cartera modelo",
    "createError": "Error al crear la cartera modelo"
  },
  "templateDoesntMatch": {
    "title": "La plantilla no coincide",
    "body": "El modelo que creó no coincide con la plantilla utilizada. ¿Desea continuar?"
  },
  "exportHeaders": {
    "securityId": "Id. de seguridad",
    "isCashEquivalent": "Equivalente al efectivo",
    "financialProductId": "Producto financiero - ID",
    "primaryAssetClassId": "Clase de activo principal - ID",
    "primaryAssetClassName": "Clase de activo principal - Nombre",
    "secondaryAssetClassId": "Clase de activo secundario - ID",
    "secondaryAssetClassName": "Clase de activo secundario - Nombre",
    "financialProductIsCash": "Producto financiero - Es efectivo",
    "financialProductTaxRank": "Producto financiero - Clasificación fiscal",
    "financialProductTicker": "Producto financiero - Ticker",
    "financialProductName": "Producto financiero - Nombre"
  },
  "exportConfig": {
    "progressTitle": "Exportación de valores de cartera modelo"
  },
  "success": {
    "cloneModelPortfolio": "Cartera modelo clonada correctamente"
  },
  "clearFilter": "Borrar filtro",
  "importCsv": {
    "title": "¿Desea importar en formato CSV?",
    "description": "Si ya creó un modelo en Excel, puede importarlo haciendo clic en el ícono Cargar situado justo encima del gráfico o arrastrando y soltando el archivo directamente en la tabla de valores.",
    "modalTitle": "Importar archivo CSV",
    "modalDescription": "Importe un archivo CSV para añadir rápidamente valores a su cartera. Asegúrese de que su CSV incluya las siguientes columnas: Security Identifier (Ticker), Porcentaje de ponderación objetivo, Tax Rank (optional).",
    "import": "Importar archivo",
    "uploadTooltip": "Cargar archivo CSV",
    "downloadTemplate": "Descargar plantilla",
    "successMessage": "Valores importados exitosamente",
    "errorMessage": "Error al importar los valores",
    "reviewTitle": "Revisar valores",
    "reviewDescription": "Los siguientes valores no están disponibles. Reemplácelos con dinero u otro valor para continuar.",
    "progress": {
      "parsing": "Analizando archivo CSV...",
      "validatingData": "Validando datos del CSV...",
      "extractingSecurities": "Extrayendo valores...",
      "fetchingSecurities": "Obteniendo valores...",
      "processingSecuritiesData": "Procesando datos de valores...",
      "validatingRows": "Validando filas del CSV...",
      "fetchingReplacementSecurities": "Obteniendo todos los valores disponibles para reemplazo...",
      "finalizing": "Finalizando importación...",
      "complete": "Importación completa"
    },
    "errors": {
      "totalAllocation": "La asignación total debe ser igual a {{total}}% (actualmente {{current}}%)",
      "selectReplacements": "Seleccione reemplazos para: {{tickers}}",
      "rowMissingIdentifier": "Fila {{rowNumber}}: Falta el identificador del valor",
      "invalidTargetWeight": "Fila {{rowNumber}} (Ticker: {{ticker}}): Peso objetivo \"{{targetWeight}}\" no válido (debe estar entre {{min}}-{{max}})",
      "invalidTaxRank": "Fila {{rowNumber}} (Ticker: {{ticker}}): Rango fiscal \"{{taxRank}}\" no válido (debe ser >= {{min}})",
      "duplicateTaxRanks": "Se encontraron rangos fiscales duplicados en el CSV. Cada rango fiscal proporcionado debe ser único.",
      "failedToImportPrefix": "Error al importar CSV:",
      "moreErrorsOne": "... y {{count}} error más",
      "moreErrorsMany": "... y {{count}} errores más",
      "emptyFile": "El archivo CSV está vacío",
      "fileTooLarge": "El tamaño del archivo ({{fileSize}}MB) supera el máximo permitido de {{maxSize}}MB. Use un archivo más pequeño.",
      "failedToParse": "Error al analizar CSV: {{reason}}",
      "maxRowsExceeded": "El CSV supera el máximo de filas permitidas ({{maxRows}}). Se encontraron al menos {{rowsProcessed}} filas.",
      "noData": "No se encontraron datos en el archivo CSV"
    }
  },
  "securityTableColumns": {
    "security": "Valor",
    "assetClass": "Clase de activo",
    "taxRank": "Rango fiscal",
    "targetPercentage": "Objetivo %",
    "portfolioPercentage": "Porcentaje de la Cartera"
  },
  "copyOfPrefix": "Copia de {{name}}",
  "modelName": "Cartera Modelo",
  "drift": {
    "sectionLabel": "Configuración de Desviación",
    "confirmTitle": "¿Volver a calcular los titulares de esta cartera modelo?",
    "confirmBody": "Esto volverá a calcular todos los titulares de esta cartera modelo. La configuración de desviación permanecerá bloqueada hasta que finalice.",
    "confirmApply": "Aplicar",
    "reviewRebalanceReport": "Revise el informe de rebalanceo para las carteras que ahora superan sus asignaciones objetivo.",
    "recalculationComplete": "Recálculo completado para {{name}}."
  },
  "securityTablePercentageInfoTitle": "Porcentaje objetivo y Porcentaje de la Cartera",
  "securityTablePercentageInfo": "**Porcentaje objetivo** — Asignación de fondos dentro de su grupo de clase de activo. Cada grupo debe sumar el 100%.\n\n**Porcentaje de la Cartera** — Asignación de fondos en toda la cartera modelo. Todos los fondos suman el 100%.",
  "securityTablePortfolioPercentageInfo": "Peso total (porcentaje dentro de la clase × porcentaje del grupo)",
  "securityTablePortfolioPercentageInfoAria": "Ayuda de la columna Porcentaje de la cartera"
}
